/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteApiProvinceV1Id } from '../fn/province/delete-api-province-v-1-id';
import { DeleteApiProvinceV1Id$Params } from '../fn/province/delete-api-province-v-1-id';
import { getApiProvinceV1Id$Json } from '../fn/province/get-api-province-v-1-id-json';
import { GetApiProvinceV1Id$Json$Params } from '../fn/province/get-api-province-v-1-id-json';
import { getApiProvinceV1Id$Plain } from '../fn/province/get-api-province-v-1-id-plain';
import { GetApiProvinceV1Id$Plain$Params } from '../fn/province/get-api-province-v-1-id-plain';
import { postApiProvinceV1Create$Json } from '../fn/province/post-api-province-v-1-create-json';
import { PostApiProvinceV1Create$Json$Params } from '../fn/province/post-api-province-v-1-create-json';
import { postApiProvinceV1Create$Plain } from '../fn/province/post-api-province-v-1-create-plain';
import { PostApiProvinceV1Create$Plain$Params } from '../fn/province/post-api-province-v-1-create-plain';
import { postApiProvinceV1Getall$Json } from '../fn/province/post-api-province-v-1-getall-json';
import { PostApiProvinceV1Getall$Json$Params } from '../fn/province/post-api-province-v-1-getall-json';
import { postApiProvinceV1Getall$Plain } from '../fn/province/post-api-province-v-1-getall-plain';
import { PostApiProvinceV1Getall$Plain$Params } from '../fn/province/post-api-province-v-1-getall-plain';
import { ProvinceModel } from '../models/province-model';
import { putApiProvinceV1Id$Json } from '../fn/province/put-api-province-v-1-id-json';
import { PutApiProvinceV1Id$Json$Params } from '../fn/province/put-api-province-v-1-id-json';
import { putApiProvinceV1Id$Plain } from '../fn/province/put-api-province-v-1-id-plain';
import { PutApiProvinceV1Id$Plain$Params } from '../fn/province/put-api-province-v-1-id-plain';

@Injectable({ providedIn: 'root' })
export class ProvinceService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `postApiProvinceV1Getall()` */
  static readonly PostApiProvinceV1GetallPath = '/private/v1/provinces';

  /**
   * Retrieves all provinces.
   *
   * Retrieves all provinces.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiProvinceV1Getall$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiProvinceV1Getall$Plain$Response(params?: PostApiProvinceV1Getall$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProvinceModel>>> {
    return postApiProvinceV1Getall$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all provinces.
   *
   * Retrieves all provinces.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiProvinceV1Getall$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiProvinceV1Getall$Plain(params?: PostApiProvinceV1Getall$Plain$Params, context?: HttpContext): Observable<Array<ProvinceModel>> {
    return this.postApiProvinceV1Getall$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProvinceModel>>): Array<ProvinceModel> => r.body)
    );
  }

  /**
   * Retrieves all provinces.
   *
   * Retrieves all provinces.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiProvinceV1Getall$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiProvinceV1Getall$Json$Response(params?: PostApiProvinceV1Getall$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProvinceModel>>> {
    return postApiProvinceV1Getall$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves all provinces.
   *
   * Retrieves all provinces.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiProvinceV1Getall$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiProvinceV1Getall$Json(params?: PostApiProvinceV1Getall$Json$Params, context?: HttpContext): Observable<Array<ProvinceModel>> {
    return this.postApiProvinceV1Getall$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProvinceModel>>): Array<ProvinceModel> => r.body)
    );
  }

  /** Path part for operation `getApiProvinceV1Id()` */
  static readonly GetApiProvinceV1IdPath = '/private/v1/provinces/{id}';

  /**
   * Retrieves the details of an province by its unique identifier (ID).
   *
   * Retrieves the details of an province by its unique identifier (ID).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiProvinceV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiProvinceV1Id$Plain$Response(params: GetApiProvinceV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ProvinceModel>> {
    return getApiProvinceV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the details of an province by its unique identifier (ID).
   *
   * Retrieves the details of an province by its unique identifier (ID).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiProvinceV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiProvinceV1Id$Plain(params: GetApiProvinceV1Id$Plain$Params, context?: HttpContext): Observable<ProvinceModel> {
    return this.getApiProvinceV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProvinceModel>): ProvinceModel => r.body)
    );
  }

  /**
   * Retrieves the details of an province by its unique identifier (ID).
   *
   * Retrieves the details of an province by its unique identifier (ID).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiProvinceV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiProvinceV1Id$Json$Response(params: GetApiProvinceV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ProvinceModel>> {
    return getApiProvinceV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the details of an province by its unique identifier (ID).
   *
   * Retrieves the details of an province by its unique identifier (ID).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiProvinceV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiProvinceV1Id$Json(params: GetApiProvinceV1Id$Json$Params, context?: HttpContext): Observable<ProvinceModel> {
    return this.getApiProvinceV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProvinceModel>): ProvinceModel => r.body)
    );
  }

  /** Path part for operation `putApiProvinceV1Id()` */
  static readonly PutApiProvinceV1IdPath = '/private/v1/provinces/{id}';

  /**
   * Updates an existing province.
   *
   * Updates an existing province.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiProvinceV1Id$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiProvinceV1Id$Plain$Response(params: PutApiProvinceV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ProvinceModel>> {
    return putApiProvinceV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing province.
   *
   * Updates an existing province.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiProvinceV1Id$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiProvinceV1Id$Plain(params: PutApiProvinceV1Id$Plain$Params, context?: HttpContext): Observable<ProvinceModel> {
    return this.putApiProvinceV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProvinceModel>): ProvinceModel => r.body)
    );
  }

  /**
   * Updates an existing province.
   *
   * Updates an existing province.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `putApiProvinceV1Id$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiProvinceV1Id$Json$Response(params: PutApiProvinceV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ProvinceModel>> {
    return putApiProvinceV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Updates an existing province.
   *
   * Updates an existing province.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `putApiProvinceV1Id$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  putApiProvinceV1Id$Json(params: PutApiProvinceV1Id$Json$Params, context?: HttpContext): Observable<ProvinceModel> {
    return this.putApiProvinceV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProvinceModel>): ProvinceModel => r.body)
    );
  }

  /** Path part for operation `deleteApiProvinceV1Id()` */
  static readonly DeleteApiProvinceV1IdPath = '/private/v1/provinces/{id}';

  /**
   * Deletes a province by its unique identifier (ID).
   *
   * Deletes a province by its unique identifier (ID).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiProvinceV1Id()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiProvinceV1Id$Response(params: DeleteApiProvinceV1Id$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteApiProvinceV1Id(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a province by its unique identifier (ID).
   *
   * Deletes a province by its unique identifier (ID).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiProvinceV1Id$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiProvinceV1Id(params: DeleteApiProvinceV1Id$Params, context?: HttpContext): Observable<void> {
    return this.deleteApiProvinceV1Id$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiProvinceV1Create()` */
  static readonly PostApiProvinceV1CreatePath = '/private/v1/provinces/create';

  /**
   * Creates a new province.
   *
   * Creates a new province.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiProvinceV1Create$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiProvinceV1Create$Plain$Response(params?: PostApiProvinceV1Create$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ProvinceModel>> {
    return postApiProvinceV1Create$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new province.
   *
   * Creates a new province.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiProvinceV1Create$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiProvinceV1Create$Plain(params?: PostApiProvinceV1Create$Plain$Params, context?: HttpContext): Observable<ProvinceModel> {
    return this.postApiProvinceV1Create$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProvinceModel>): ProvinceModel => r.body)
    );
  }

  /**
   * Creates a new province.
   *
   * Creates a new province.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiProvinceV1Create$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiProvinceV1Create$Json$Response(params?: PostApiProvinceV1Create$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ProvinceModel>> {
    return postApiProvinceV1Create$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new province.
   *
   * Creates a new province.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiProvinceV1Create$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiProvinceV1Create$Json(params?: PostApiProvinceV1Create$Json$Params, context?: HttpContext): Observable<ProvinceModel> {
    return this.postApiProvinceV1Create$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProvinceModel>): ProvinceModel => r.body)
    );
  }

}
